export const CHECK_AUTH = 'checkAuth'
export const FETCH_DASHBOARD_MARKET_VIEW = 'fetchMarketViewPost'
export const FETCH_DASHBOARD_SECTOR_SUMMARY = 'fetchSectorSummaryPost'
export const PURGE_AUTH = 'logOut'
export const REMOVETAB = 'removetab'
export const ADDTAB = 'addtab'
export const FETCH_TABS = 'gettabs'
export const CHANGEACTIVETAB = 'changeactivetab'
export const FETCH_POST = 'getpost'
export const FETCH_SEARCH_FILTERS = 'searchfilters'
export const SET_ANALYST_STATE = 'setanaly_state'
export const SET_TIME_STATE = 'set_time_state'
export const SET_RESEARCH_TYPE = 'set_research_type_state'
export const SET_SEARCH_RESULT_LOADING = 'set_search_loading'
export const LOAD_MORE_RESULT = 'load_more_search_result'
export const SET_CURRENT_PAGE = 'set_current_page'
export const SET_LOAD_MORE_STATUS = 'set_laod_more'
export const SET_CUSTOM_DATE = 'set_custom_date'
export const SET_SEARCH_KEY = 'set_search_key'
export const SET_ORDER_BY = 'set_order_by'
export const FETCH_DASHBOARD_RECENT_MENTIONED =
  'FETCH_DASHBOARD_RECENT_MENTIONED'
export const FETCH_DASHBOARD_EQUITY_RESEARCH = 'FETCH_DASHBOARD_EQUITY_RESEARCH'
export const FETCH_DASHBOARD_FOCUS_LIST = 'FETCH_DASHBOARD_FOCUS_LIST'
export const FETCH_GLOBAL_OUTLOOK = 'FETCH_GLOBAL_OUTLOOK'
export const FETCH_FEATURE = 'FETCH_FEATURE'
export const LOGOUT_ACCOUNT = 'LOGOUT_ACCOUNT'
export const RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER'
export const SET_SEARCH_FILTER = 'SET_SEARCH_FILTER'
export const SET_SEARCH_SYMBOL = 'SET_SEARCH_SYMBOL'
export const SET_ANALYST_SEARCH = 'SET_ANALYST_SEARCH'
export const SET_RESEARCH_TYPE_ANALYST_SEARCH_FILTER =
  'SET_RESEARCH_TYPE_ANALYST_SEARCH_FILTER'
export const FETCH_ANALYST_BIO = 'FETCH_ANALYST_BIO'
export const FETCH_DASHBOARD_FOUCS_CHART = 'FETCH_DASHBOARD_FOUCS_CHART'
export const FETCH_DASHBOARD_FOUCS_CHART_LIST =
  'FETCH_DASHBOARD_FOUCS_CHART_LIST'
export const WON_HEADER_MENU = 'WON_HEADER_MENU'
export const LOAD_SEARCH_RESULT = 'LOAD_SEARCH_RESULT'
export const LOAD_ANALYST_RESULT = 'LOAD_ANALYST_RESULT'
export const FETCH_DASHBOARD_APAC = 'FETCH_DASHBOARD_APAC'
export const FETCH_DASHBOARD_EUROPE = 'FETCH_DASHBOARD_EUROPE'
export const FETCH_DASHBOARD_LATAM = 'FETCH_DASHBOARD_LATAM'
export const FETCH_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL =
  'FETCH_DASHBOARD_RESEARCHCH_ANALYST_MORING_CALL'
export const FETCH_DASHBOARD_MONTHLY_REPORTS = 'FETCH_DASHBOARD_MONTHLY_REPORTS'
export const FETCH_LARGE_CAP = 'FETCH_LARGE_CAP'
export const FETCH_WHITE_PAPERS = 'FETCH_WHITE_PAPERS'
export const FETCH_IOP_LISTING = 'FETCH_IOP_LISTING'
export const FETCH_ECON_SUMMARY = 'FETCH_ECON_SUMMARY'
export const FETCH_TREND_WATCH = 'FETCH_TREND_WATCH'
export const FETCH_ASIA_WATCH = 'FETCH_ASIA_WATCH'
export const FETCH_WON_EUROPE_TODAY = 'FETCH_WON_EUROPE_TODAY'
export const FETCH_GLOBAL_LAGGARDS = 'FETCH_GLOBAL_LAGGARDS'
export const FETCH_WON_GLOBAL_VIEW = 'FETCH_WON_GLOBAL_VIEW'
export const FETCH_STRATEGY_VIEW = 'FETCH_STRATEGY_VIEW'
export const FOOTER_MENU = 'FOOTER_MENU'
export const SET_LOCALSTORAGE_SEARCH_FILTER = 'SET_LOCALSTORAGE_SEARCH_FILTER'
export const SET_VIMEO_THUMBNAIL = 'SET_VIMEO_THUMBNAIL'
export const STORE_ANALYST_TO_LOCALSTORAGE = 'STORE_ANALYST_TO_LOCALSTORAGE'
export const SET_CURRENT_PAGE_ANALYST = 'SET_CURRENT_PAGE_ANALYST'
export const SET_LOAD_MORE_STATUS_ANALYST = 'SET_LOAD_MORE_STATUS_ANALYST'
export const LOAD_MORE_RESULT_ANALYST = 'LOAD_MORE_RESULT_ANALYST'
export const SET_ORDER_BY_ANALYST = 'SET_ORDER_BY_ANALYST'
export const SET_LOCALSTORAGE_SEARCH_FILTER_ANALYST =
  'SET_LOCALSTORAGE_SEARCH_FILTER_ANALYST'
export const SUBMIT_ANALYST_CONTACT = 'SUBMIT_ANALYST_CONTACT'
export const CHECK_AUTH_ON_LOAD = 'CHECK_AUTH_ON_LOAD'
export const GET_ENTITLED = 'GET_ENTITLED'
export const ASK_ANALYST = 'ASK_ANALYST'
export const RESET_TIME_STATE = 'RESET_TIME_STATE'
export const GET_LOGIN_HELP_TEXT = 'GET_LOGIN_HELP_TEXT'
export const RESET_ORDER_BY_FROM_HOME = 'RESET_ORDER_BY_FROM_HOME'
export const SET_ENTITLEMENT_VALUE = 'SET_ENTITLEMENT_VALUE'
export const GET_EXTERNALURL_SEARCH = 'GET_EXTERNALURL_SEARCH'
export const FETCH_DASHBOARD_WEBINAR = 'FETCH_DASHBOARD_WEBINAR'
export const FETCH_DASHBOARD_CAFL = 'FETCH_DASHBOARD_CAFL'
export const FETCH_EREADER = 'FETCH_EREADER'
export const FETCH_DERIVATIVES_REPORT = 'FETCH_DERIVATIVES_REPORT'
export const FETCH_DASHBOARD_YOUR_EBOOK = 'FETCH_DASHBOARD_YOUR_EBOOK'
export const FETCH_FEATURE_SINGLE_POST = 'FETCH_FEATURE_SINGLE_POST'
export const FETCH_US_MARKET_OVERVIEW = 'FETCH_US_MARKET_OVERVIEW'
export const FETCH_SECTOR_SPOTLIGHT = 'FETCH_SECTOR_SPOTLIGHT'
export const FETCH_Analyst_Insights_Video_Series ='FETCH_Analyst_Insights_Video_Series'




// WEBPACK FOOTER //
// ./src/store/actions.type.js